import gql from 'graphql-tag'

export const companyAllowedEligibilitiesUpdate = gql`
  mutation companyAllowedEligibilitiesUpdate($updateData: [CompanyEligiblitiesInput!]!) {
    companyAllowedEligibilitiesUpdate(input: { updateData: $updateData }) {
      success
    }
  }
`
